<template>
  <div class="not_found">
    <a-result status="404" title="404" sub-title="抱歉，您访问的页面不存在。">
      <template #extra>
        <a-button type="primary" @click="backHome">返回首页</a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    backHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.not_found {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  padding: 40px 20px 20px;
}
</style>
